/**
 * The patient banner in a thread: a message that links patients gets a full-width bar above it naming them, with their
 * chat and file. It marks where the patient being talked about changes, so a run of messages about the same patient
 * has one bar, not one each.
 */

/** Which patients a message links to, as one comparable key ('' for none). */
export function patientContextKey(links: { conversationId: string }[]): string {
  return links.map((l) => l.conversationId.toLowerCase()).sort().join('|');
}

/**
 * For each message (in order), whether it gets the banner: it links patients, and they differ from the last message
 * that did, or a new day has started. With `everyTime`, every linking message gets one (a network chat, where each
 * message carries its own Share action).
 */
export function showPatientContext(rows: { key: string; newDay: boolean }[], everyTime: boolean): boolean[] {
  let last = '';
  return rows.map(({ key, newDay }) => {
    if (newDay) last = '';
    if (!key) return false;
    const show = everyTime || key !== last;
    last = key;
    return show;
  });
}
